import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

export interface ItineraryItemCardProps {
  children?: React.ReactNode;
}

// Base wrapper to keep look-and-feel consistent across item types
const renderSafeChildren = (children: React.ReactNode) => {
  if (children === null || children === undefined) return null;
  // Primitive text/number should be wrapped in <Text> when inside a View
  if (typeof children === 'string' || typeof children === 'number') {
    return <Text>{String(children)}</Text>;
  }
  if (Array.isArray(children)) {
    return children.map((c, i) => (typeof c === 'string' || typeof c === 'number' ? <Text key={i}>{String(c)}</Text> : (c as any)));
  }
  return children as any;
};

const ItineraryItemCard: React.FC<ItineraryItemCardProps> = ({ children }) => {
  return <View style={styles.card}>{renderSafeChildren(children)}</View>;
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingVertical: 14,
    paddingHorizontal: 12,
    // react-native-web deprecates shadow* props — use boxShadow on web
    ...Platform.select({
      web: {
        // box-shadow: offsetX offsetY blurRadius color
        boxShadow: '0px 8px 20px rgba(0,0,0,0.06)',
      },
      default: {
        shadowColor: '#000',
        shadowOpacity: 0.06,
        shadowOffset: { width: 0, height: 8 },
        shadowRadius: 20,
        elevation: 2,
      },
    }),
  },
});

export default ItineraryItemCard;
